import React, { useState } from "react";
import ShowToast from "components/ShowToast";
import { fetchWrapper } from "utils/apiFetch";

// Sends money to a single already-added Cyrus beneficiary via
// billpay_send_money. Mirrors MakeWalletPaymentModal's contract:
// on success it calls onSuccess(referenceNum) with just the string.
const MakeBillpaySendMoneyModal = ({ show, onClose, userData, onSuccess }) => {
  const [amount, setAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [transectionMode, setTransectionMode] = useState("IMPS/NEFT/RTGS");
  const [submitting, setSubmitting] = useState(false);

  if (!show || !userData) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!amount || Number(amount) <= 0) {
      ShowToast("Enter a valid amount", "warning");
      return;
    }

    setSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("transection_mode", transectionMode);
      formData.append("amount", amount);
      formData.append("holder_name", userData.name);
      formData.append("mobile", userData.mobile || "");
      formData.append("comments", remark || "Bill Pay Settlement");
      formData.append("beneficiaryid", userData.cyrusid);
      formData.append("remark", remark);

      const res = await fetchWrapper("https://pro.mokshiq.in/billpay_send_money", {
        method: "POST",
        body: formData,
      });

      if (res?.status) {
        ShowToast(res.message || "Payout submitted successfully", "success");
        onSuccess && onSuccess(res.reference_num);
      } else {
        // Some responses (e.g. pending) still return a reference_num with status:false
        ShowToast(res?.message || "Payout failed", "danger");
        if (res?.reference_num) {
          onSuccess && onSuccess(res.reference_num);
        }
      }
    } catch (err) {
      ShowToast("Something went wrong while sending money", "danger");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <h5>Settle to {userData.name}</h5>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="info-row">
              <span>Account No</span>
              <b>{userData.account}</b>
            </div>
            <div className="info-row">
              <span>IFSC</span>
              <b>{userData.IFSC_Code}</b>
            </div>
            <div className="info-row">
              <span>Beneficiary ID</span>
              <b>{userData.cyrusid}</b>
            </div>

            <div className="form-group">
              <label>Transfer Mode</label>
              <select value={transectionMode} onChange={(e) => setTransectionMode(e.target.value)}>
                <option value="IMPS/NEFT/RTGS">IMPS / NEFT / RTGS</option>
                <option value="IMPS">IMPS</option>
                <option value="NEFT">NEFT</option>
                <option value="RTGS">RTGS</option>
              </select>
            </div>

            <div className="form-group">
              <label>Amount *</label>
              <input
                type="number"
                min="1"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Remark</label>
              <input value={remark} onChange={(e) => setRemark(e.target.value)} placeholder="Optional remark" />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn secondary" onClick={onClose} disabled={submitting}>
              Cancel
            </button>
            <button type="submit" className="btn primary" disabled={submitting}>
              {submitting ? "Processing..." : "Settle Now"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MakeBillpaySendMoneyModal;